'use strict';

angular.module('formonlineApp')
		.controller('SidebarController', function ($scope, $state, $log, Principal, SidebarService) {

        $scope.isAuthenticated = Principal.isAuthenticated;
		$scope.$state = $state;
		$scope.service = SidebarService;

		$scope.node = SidebarService.getNode();

		$scope.removeSsMenu = function (indexMenu, indexSsMenu) {
				SidebarService.removeSsMenu(indexMenu, indexSsMenu);
		};

		$scope.isSsMenuSelected = function (id) {
			var idSelected = SidebarService.getIdSsMenuSelected();
			if (id !== undefined && idSelected !== undefined && id.toString() === idSelected.toString()) {
				return 'selected';
			}
			return '';
		};


	});
